$(document).ready(function() {

const params = new URLSearchParams(window.location.search);
const purchaseOption = params.get('purchaseoption');
 
if (purchaseOption === 'onetime') {
  $('.tabs').children('.tb').removeClass('active');
  $('.tabs').find('.tb').eq(1).addClass('active');
}

  
    var od_variantdata = $('.oddit_product').data('productvariants');
    $.each(od_variantdata, function(index, val) {
         /* iterate through array or object */
        //console.log('ID: ', val);
    });
  
  /** Flavour Offer Part Click Option functionality **/
setTimeout(function() {
    var flavourstatus = $('.oddit_status').data('flavourstatus');
    if (!flavourstatus) {
      var od_variantdata = $('.oddit_product').data('productvariants');
      var od_productDiscount = $('.oddit_product').data('discount');
      var od_producthandle = $('.oddit_status').data('producthandle');
      var od_filter = '';
      var VariantsInfo = getVariantsInfo(od_variantdata, od_productDiscount, od_filter, od_producthandle);

     
      //console.log('Non Flavourd Variants Info',VariantsInfo);
      if (typeof VariantsInfo[0] != "undefined")
      {
        console.log('1111');
      $('.offer-part.op1').attr('data-sellingplan', VariantsInfo[0].sellingplan);
      $('.offer-part.op1').attr('data-variationid', VariantsInfo[0].id);
      $('.offer-part.op1').attr('data-total', JSON.stringify(VariantsInfo[0]));
      
      }
      if (typeof VariantsInfo[1] != "undefined")
      {
        console.log('1112');
      $('.offer-part.op2').attr('data-sellingplan', VariantsInfo[1].sellingplan);
      $('.offer-part.op2').attr('data-variationid', VariantsInfo[1].id);
      $('.offer-part.op2').attr('data-total', JSON.stringify(VariantsInfo[1]));
      }
      if (typeof VariantsInfo[2] != "undefined")
      {
        console.log('1113');
      $('.offer-part.op3').attr('data-sellingplan', VariantsInfo[2].sellingplan);
      $('.offer-part.op3').attr('data-variationid', VariantsInfo[2].id);
      $('.offer-part.op3').attr('data-total', JSON.stringify(VariantsInfo[2]));
      }
    }
var url = window.location.href;
var arguments = url.split('?').pop().split('=').pop();

var urli = new URL(window.location.href);
var params = new URLSearchParams(urli.search);
var varianti = params.get('variant');




  
  if (localStorage.getItem("optionsel")) {
 var getlo = localStorage.getItem("optionsel");
  }
  
var pronames = $.trim($('.pr_name').html());

$(document).ready(function() {

  // 1. Get the current variant ID from the URL query string.

  var params = new URLSearchParams(window.location.search);

  var currentVariantId = params.get('variant'); // e.g., "39545378111566"
 
  if (currentVariantId) {

    // -------------------------------------------

    // First, handle the .dv element:

    // -------------------------------------------

    // Get the JSON string from the product container and parse it.

    var $productDiv = $('.rgt_col.info.oddit_product');

    var variantsData = $productDiv.attr('data-productvariants');
 
    try {

      var variants = JSON.parse(variantsData);

    } catch (e) {

      console.error("Error parsing variants JSON:", e);

      return;

    }
 
    // Find the variant object matching the current variant ID.

    var matchedVariant = variants.find(function(variant) {

      return variant.id == currentVariantId;

    });
 
    if (matchedVariant) {

      // Use a property (for example, option1) from the variant to find the corresponding .dv element.

      var option1Value = matchedVariant.option1; // e.g., "Peach and Pineapple"
 
      // Remove any active class from all .dv elements.

      $('.dv.active').removeClass('active');
 
      // Find the .dv element whose data-text equals the option1 value.

      var $dvElement = $('.dv').filter(function() {

        return $(this).data('text') === option1Value;

      }).first();
 
      if ($dvElement.length) {
 

        $dvElement.addClass('active');

        // Trigger a click on the matching .dv element.

        $dvElement.trigger('click');
        var getpo = $('.tabs').find('.tb.active').find('.pr.sub_each_price').html();
    
        $('.tbcnt').find('.add_to_cart').find('.totalprice').text(getpo);
if($('.offer-part.op1').hasClass('active')){
  totflavorcount ='Choose 6 Flavours';
}
if($('.offer-part.op2').hasClass('active')){
    totflavorcount ='Choose 3 Flavours';
}
if($('.offer-part.op3').hasClass('active')){
    totflavorcount ='Choose 1 Flavour';
}
$('.add_to_cart').find('span.dd').html(totflavorcount);
      } else {

        console.warn("No matching .dv element found for option1 value:", option1Value);

      }
 
      // -------------------------------------------

      // Next, handle the .offer-part element:

      // -------------------------------------------

      // Remove any active class from all .offer-part elements.

      $('.offer-part.active').removeClass('active');
 
      // Find the .offer-part element whose data-variationid matches the current variant ID.

      var $offerPart = $('.offer-part').filter(function() {

        return $(this).attr('data-variationid') === currentVariantId;

      }).first();
 
      if ($offerPart.length) {

        $offerPart.addClass('active');

        // Trigger a click on the matching .offer-part element.

        $offerPart.trigger('click');

      } else {

        console.warn("No matching .offer-part element found for variant ID:", currentVariantId);

      }

    } else {

    

    }

  }

});

 
// //$('.tb.active').trigger('click');
// }
//   else{
//        $('.dv.active').trigger('click');
//     $('.offer-part.active').trigger('click');
//     $('.tb.active').trigger('click');
//             if($('.offer-part.op1').hasClass('active')){
//   $('.onselectionofweeks').show();
// $('.onselectionofweeks').addClass('active');
// }
//   }



 // if((getlo) && (getlo != 'Women')){
 //    $(".dv[data-text='"+getlo+"']").trigger('click');
   
 //  }
 // alert(arguments);
  if(varianti == '44335002059042'){
    $(".dv[data-text='Women']").trigger('click');
  
  }


  if(varianti == '39545378046030'){
    $('.add_to_cart').addClass('disable');
  }
  
  
 // if(getlo){
 //    $(".dv[data-text='"+getlo+"']").trigger('click');
 //  }



if(varianti ){
 
$(".offer-part[data-variationid='"+arguments+"']").trigger('click');
  
}
 

var procomp = $.trim($('.pr_name').html());
 
  if(procomp == 'Joint Powder Collagen Complexi'){
$('.add_to_cart').addClass('disable');
 $('.add_to_cart').find('span.dd').html('Out Of Stock');

  }
  
    
}, 10);
$(document).on('click', '.dv', function(event) {

  event.preventDefault();
  /* Act on the event */
  $('.dv').removeClass('active');
  $(this).addClass('active');

    var slidefr = $(this).attr('data-text');
 
  var titlepro = $('.pr_name').html();
  if(titlepro == 'Glow Powder Marine Collagen Drink' || titlepro == 'Joint Powder' ){
if(slidefr == 'Lemonn and Mintt'){
  $('.add_to_cart').addClass('disable'); 
  $('.add_to_cart').find('span.dd').html('Out Of Stock');
}
  else{

    if($('.offer-part.op1').hasClass('active')){
  totflavorcount ='Choose 6 Flavours';
}
if($('.offer-part.op2').hasClass('active')){
    totflavorcount ='Choose 3 Flavours';
}
if($('.offer-part.op3').hasClass('active')){
    totflavorcount ='Choose 1 Flavour';
}

    $('.add_to_cart').removeClass('disable');
    $('.add_to_cart').find('span.dd').html(totflavorcount);
  }
  }

  if(slidefr == 'Men'){
    
     //  $('.add_to_cart').addClass('disable'); 
 // $('.add_to_cart').find('span.dd').html('Out Of Stock');

 $('.hero-banner').slick('slickGoTo', 1);
    console.log('changeme');
  }
  else{
    

    $('.add_to_cart').removeClass('disable');
    $('.add_to_cart').find('span.dd').html('Add To Cart');

if($('.offer-part.op1').hasClass('active')){
  totflavorcount ='Choose 6 Flavours';
}
if($('.offer-part.op2').hasClass('active')){
    totflavorcount ='Choose 3 Flavours';
}
if($('.offer-part.op3').hasClass('active')){
    totflavorcount ='Choose 1 Flavour';
}

 $('.add_to_cart').find('span.dd').html(totflavorcount);


  }
  
  if(slidefr == 'Women'){
   setTimeout(function(){ 
 $('.hero-banner').slick('slickGoTo', 2);
    console.log('changewo');
     }, 500);
  }
 

  
   
  
  
  if(slidefr == 'Mixed'){
  
   $('.hero-banner').slick('slickGoTo', 0);
  } 
  

  
  $('.dd_lft').find('.lbl').text($(this).data('text'));
  $('.dd_lft').find('.lbl').data('id',$(this).data('id'));
  var od_variantdata = $('.oddit_product').data('productvariants');
  var od_productDiscount = $('.oddit_product').data('discount');
  var od_producthandle = $('.oddit_status').data('producthandle');
  var od_filter = $(this).data('text');
  var VariantsInfo = getVariantsInfo(od_variantdata, od_productDiscount, od_filter, od_producthandle);
  //console.log('Flavourd Variants Info',VariantsInfo);
  $('.offer-part').show();
var purchaseoptiond = $('.tb.active').attr('rel');
  console.log(VariantsInfo);
   var pronames = $.trim($('.pr_name').html());
   
  if (typeof VariantsInfo[0] != "undefined" && pronames != 'Glow Powder Marine Collagen Drink' && pronames != 'Joint Powder')
  {
       var titlepro = $('.pr_name').html();
  if(titlepro == 'Glow Powder Marine Collagen Drink' ||  titlepro == 'Joint Powder'){
  
      if(purchaseoptiond == 'subscription'){
        $('.offer-part.op1').html('<div class="top_main_insupp">Best Deal</div><div class="top_middle_insupp">'+VariantsInfo[0][od_filter].supply+'</div><div class="top_last_insupp">£15.99 / pouch</div>');
    console.log('333');
      }else{

         $('.offer-part.op1').html('<div class="top_main_insupp">Best Deal</div><div class="top_middle_insupp">'+VariantsInfo[0][od_filter].supply+'</div><div class="top_last_insupp">£19.99 / pouch</div>');
   console.log('444');
      }
     
    
  }
    else{
var variantData = VariantsInfo[0][od_filter];
// Extract the number of bottles from the 'supply' field
var supply = parseInt(variantData.supply.split(" ")[0]); // This will extract the number (e.g., '1' from '1 Bottle')
  if(variantData.supply == '6 Bottles'){
   var supif = '';
 }
      else{
        var supif = ''; 
      }
// Calculate the price for one-time purchase and subscription
var otpEachPrice = variantData.price/100; // Price for one-time selection
        var otpEachPrice = (otpEachPrice/ supply).toFixed(2);
var subEachPrice = parseFloat(variantData.sub_price); // Price for subscription selection
   var subprice  = (subEachPrice / supply).toFixed(2);
    //alert(2);
      if(purchaseoptiond == 'subscription'){
   //$('.offer-part.op1').html('<div class="top_main_insupp">Best Deal</div><div class="top_middle_insupp">'+VariantsInfo[0][od_filter].supply+'</div><div class="top_last_insupp">£'+subprice+' / bottle</div>');   
     // $('.offer-part.op3').html(VariantsInfo[0][od_filter].supply);
      console.log('55');
      }
      else{
          //$('.offer-part.op1').html('<div class="top_main_insupp">Best Deal</div><div class="top_middle_insupp">'+VariantsInfo[0][od_filter].supply+'</div><div class="top_last_insupp">£'+otpEachPrice+' / bottle</div>');   
  console.log('66');
      }
      
      
      }
 // $('.offer-part.op1').html(VariantsInfo[0][od_filter].supply);
  $('.offer-part.op1').attr('data-sellingplan', VariantsInfo[0][od_filter].sellingplan);
  $('.offer-part.op1').attr('data-variationid', VariantsInfo[0][od_filter].id);
 
 // $('.offer-part.op1').attr('data-total', JSON.stringify(VariantsInfo[0][od_filter]));
 
  }
  else
  {
    if(pronames == 'Glow Powder Marine Collagen Drink' ||  pronames == 'Joint Powder'){}
    else{
    $('.offer-part.op1').hide();
    }
  }
  if (typeof VariantsInfo[1] != "undefined" && pronames != 'Glow Powder Marine Collagen Drink' && pronames != 'Joint Powder')
  {
    var titlepro = $('.pr_name').html();
  if(titlepro == 'Glow Powder Marine Collagen Drink' || titlepro == 'Joint Powder'){
    if(VariantsInfo[1][od_filter].supply == '6 Week Supply'){
       if(purchaseoptiond == 'subscription'){
            $('.offer-part.op2').html('<div class="top_middle_insupp">'+VariantsInfo[1][od_filter].supply+'</div><div class="top_last_insupp">£19.19 / pouch</div>');
  
       }
      else{
          $('.offer-part.op2').html('<div class="top_middle_insupp">'+VariantsInfo[1][od_filter].supply+'</div><div class="top_last_insupp">£23.99 / pouch</div>');
   
      }
   
    }
  }
    else{

var variantData = VariantsInfo[1][od_filter];
// Extract the number of bottles from the 'supply' field
var supply = parseInt(variantData.supply.split(" ")[0]); // This will extract the number (e.g., '1' from '1 Bottle')
 
// Calculate the price for one-time purchase and subscription
var otpEachPrice = variantData.price/100; // Price for one-time selection
        var otpEachPrice = (otpEachPrice/ supply).toFixed(2);
var subEachPrice = parseFloat(variantData.sub_price); // Price for subscription selection
   var subprice  = (subEachPrice / supply).toFixed(2);
     if(purchaseoptiond == 'subscription'){
   $('.offer-part.op2').html('<div class="top_middle_insupp">'+VariantsInfo[1][od_filter].supply+'</div><div class="top_last_insupp">£'+subprice+' / bottle</div>');   
     // $('.offer-part.op2').html(VariantsInfo[0][od_filter].supply);
      }
      else{
          $('.offer-part.op2').html('<div class="top_middle_insupp">'+VariantsInfo[1][od_filter].supply+'</div><div class="top_last_insupp">£'+otpEachPrice+' / bottle</div>');   
 
      }
     // $('.offer-part.op2').html(VariantsInfo[1][od_filter].supply);
    }
  //$('.offer-part.op2').html(VariantsInfo[1][od_filter].supply);
  $('.offer-part.op2').attr('data-sellingplan', VariantsInfo[1][od_filter].sellingplan);
  $('.offer-part.op2').attr('data-variationid', VariantsInfo[1][od_filter].id);
  $('.offer-part.op2').attr('data-total', JSON.stringify(VariantsInfo[1][od_filter]));
  }
  else
  {
     if(pronames == 'Glow Powder Marine Collagen Drink' || pronames == 'Joint Powder'){}
    else{
    $('.offer-part.op2').hide();
    }
  }
  if (typeof VariantsInfo[2] != "undefined" && pronames != 'Glow Powder Marine Collagen Drink' && pronames != 'Joint Powder')
  {
var titlepro = $('.pr_name').html();
  if(titlepro == 'Glow Powder Marine Collagen Drink' || titlepro == 'Joint Powder'){
    
     if(purchaseoptiond == 'subscription'){
          $('.offer-part.op3').html('<div class="top_middle_insupp">'+VariantsInfo[2][od_filter].supply+'</div><div class="top_last_insupp">£21.59 / pouch</div>');
  
      }
      else{
           $('.offer-part.op3').html('<div class="top_middle_insupp">'+VariantsInfo[2][od_filter].supply+'</div><div class="top_last_insupp">£26.99 / pouch</div>');
  
      }
      
   
    
  }
    else{


var variantData = VariantsInfo[2][od_filter];
// Extract the number of bottles from the 'supply' field
var supply = parseInt(variantData.supply.split(" ")[0]); // This will extract the number (e.g., '1' from '1 Bottle')
 if(variantData.supply == '6 Bottles'){
   var supif = '';
 }
      else{
        var supif = ''; 
      }
// Calculate the price for one-time purchase and subscription
var otpEachPrice = variantData.price/100; // Price for one-time selection
   var otpEachPrice = (otpEachPrice/ supply).toFixed(2);     
var subEachPrice = parseFloat(variantData.sub_price); // Price for subscription selection
   var subprice  = (subEachPrice / supply).toFixed(2);
    if(purchaseoptiond == 'subscription'){
   $('.offer-part.op3').html(supif+'<div class="top_middle_insupp">'+VariantsInfo[2][od_filter].supply+'</div><div class="top_last_insupp">£'+subprice+' / bottle</div>');   
     // $('.offer-part.op1').html(VariantsInfo[0][od_filter].supply);
      }
      else{
          $('.offer-part.op3').html(supif+'<div class="top_middle_insupp">'+VariantsInfo[2][od_filter].supply+'</div><div class="top_last_insupp">£'+otpEachPrice+' / bottle</div>');   
 
      }
     // $('.offer-part.op1').html(VariantsInfo[2][od_filter].supply);
    }
  
  $('.offer-part.op3').attr('data-sellingplan', VariantsInfo[2][od_filter].sellingplan);
  $('.offer-part.op3').attr('data-variationid', VariantsInfo[2][od_filter].id);
  $('.offer-part.op3').attr('data-total', JSON.stringify(VariantsInfo[2][od_filter]));
  }
  else
  {
    if(pronames == 'Glow Powder Marine Collagen Drink' || pronames == 'Joint Powder' ){}
    else{
    $('.offer-part.op3').hide();
    }
  }
  if(!$('.offer-part.active').is(":visible"))
  {
     $('.offer-part.op1').trigger('click');
  }
  $('.offer-part.active').trigger('click');

var procomp = $.trim($('.pr_name').html());
 
  if(procomp == 'Joint Powder Collagen Complexi'){
$('.add_to_cart').addClass('disable');
 $('.add_to_cart').find('span.dd').html('Out Of Stock');

  }
});
/** Week supply Offer Part Click Option functionality **/
$(document).on('click', '.offer-part', function(event) {
  event.preventDefault();
  /* Act on the event */
  $('.offer-part').removeClass('active');
  $(this).addClass('active');
  var offerdata = JSON.parse($(this).attr('data-total'));
  //console.log('offerdata',offerdata);
  //console.log($(this).attr('data-variationid'));
  //console.log(window.location.href.split('?')[0]);
  var variantid = $(this).attr('data-variationid');
  var getflname = $.trim($(this).find('.top_middle_insupp').html());
 if(getflname == '12 Weeks'){
  $('.onselectionofweeks').show();
$('.onselectionofweeks').addClass('active');
}
  else{
      $('.onselectionofweeks').hide();
$('.onselectionofweeks').removeClass('active');
  }
  //for mint out of stock
// var slidefr = $('.dv.active').attr('data-text');
  var titlepro = $('.pr_name').html();

  if(titlepro == 'Glow Powder Marine Collagen Drink' || titlepro == 'Joint Powder'){

   if(variantid == '395453780460304' || variantid == '395453780132622' || variantid == '395453779804944' ){
  $('.add_to_cart').addClass('disable');
 $('.add_to_cart').find('span.dd').html('Out Of Stock');  
     
}
  else{
if($('.offer-part.op1').hasClass('active')){
  totflavorcount ='Choose 6 Flavours';
 

}
if($('.offer-part.op2').hasClass('active')){
    totflavorcount ='Choose 3 Flavours';
   
}
if($('.offer-part.op3').hasClass('active')){
    totflavorcount ='Choose 1 Flavour';
  
}
    $('.add_to_cart').removeClass('disable');
    $('.add_to_cart').find('span.dd').html(totflavorcount);
  } 
  }


  
// if (localStorage.getItem("optionsel")) {

//   localStorage.removeItem("mytime");
//       var getvalofsel = $('.dv.active').attr('data-text');
  
//   if(getvalofsel){
//  localStorage.setItem("optionsel", getvalofsel);
//   }
// }
//   else{
//      var getvalofsel = $('.dv.active').attr('data-text');
  
//   if(getvalofsel){
//  localStorage.setItem("optionsel", getvalofsel);
//   }
//   }
  
  window.history.replaceState(null, null, "?variant="+variantid);
  var purchaseoption = $('.tb.active').attr('rel');
  //$('.otp_cross_price').text('£'+parseFloat(offerdata.otp_cross_price).toFixed(2));
  //$('.otp_each_price').text('£'+(offerdata.price/100).toString());
  //$('.sub_each_price').text('£'+parseFloat(offerdata.sub_price).toFixed(2));
  //$('.sub_cross_price').text('£'+(offerdata.price/100).toString());
  //$('.otp_each_price').text('£'+parseFloat(offerdata.otp_each_price).toFixed(2));
  //$('.sub_each_price').text('£'+parseFloat(offerdata.sub_each_price).toFixed(2));
  //$('.sub_cross_price').text('£'+parseFloat(offerdata.sub_cross_price).toFixed(2));
  if(parseFloat(offerdata.otp_cross_price) === 0)
  {
    $('.otp_cross_price').text('');
  }
  var variantprice;
    if (purchaseoption == 'subscription') {
         variantprice =  offerdata.sub_price;
    }
    else if (purchaseoption == 'onetime'){
          variantprice =  (offerdata.price/100).toString();
    }
    variantprice = '£'+variantprice;
    //console.log('variantprice',variantprice);
    //$('.totalprice').text(variantprice);

var getlengthfor = $('.ddcont').find('.dv').length;

  if(getlengthfor > 0){
  }
  else{  
 

var od_variantdata = $('.oddit_product').data('productvariants');
  var od_productDiscount = $('.oddit_product').data('discount');
  var od_producthandle = $('.oddit_status').data('producthandle');
 
// Get the title
   var od_filter = '';

  var VariantsInfo = getVariantsInfo(od_variantdata, od_productDiscount, od_filter, od_producthandle);
  //console.log('Flavourd Variants Info',VariantsInfo);
  $('.offer-part').show();
var purchaseoptiond = $('.tb.active').attr('rel');
  console.log(VariantsInfo);
  if (typeof VariantsInfo[0] != "undefined")
  {


var variantData = VariantsInfo[0];
// Extract the number of bottles from the 'supply' field
var supply = parseInt(variantData.supply.split(" ")[0]); // This will extract the number (e.g., '1' from '1 Bottle')
 
// Calculate the price for one-time purchase and subscription
var otpEachPrice = variantData.price/100; // Price for one-time selection
    var otpEachPrice = (otpEachPrice/ supply).toFixed(2);
var subEachPrice = parseFloat(variantData.sub_price); // Price for subscription selection
   var subprice  = (subEachPrice / supply).toFixed(2);
   
if(purchaseoptiond == 'subscription'){
   //$('.offer-part.op1').html('<div class="top_main_insupp">Best Deal</div><div class="top_middle_insupp">'+VariantsInfo[0].supply+'</div><div class="top_last_insupp">£'+subprice+' / bottle</div>');   
     // $('.offer-part.op3').html(VariantsInfo[0][od_filter].supply);
  }
  else{
    //$('.offer-part.op1').html('<div class="top_main_insupp">Best Deal</div><div class="top_middle_insupp">'+VariantsInfo[0].supply+'</div><div class="top_last_insupp">£'+otpEachPrice+' / bottle</div>');   
   
  }  


    
  }
  else
  {
    
    $('.offer-part.op1').hide();
  }
  if (typeof VariantsInfo[1] != "undefined")
  {


var variantData = VariantsInfo[1];
// Extract the number of bottles from the 'supply' field
var supply = parseInt(variantData.supply.split(" ")[0]); // This will extract the number (e.g., '1' from '1 Bottle')
 
// Calculate the price for one-time purchase and subscription
var otpEachPrice = variantData.price/100; // Price for one-time selection
var otpEachPrice = (otpEachPrice/ supply).toFixed(2);
    
var subEachPrice = parseFloat(variantData.sub_price); // Price for subscription selection
   var subprice  = (subEachPrice / supply).toFixed(2);
  if(purchaseoptiond == 'subscription'){
  // $('.offer-part.op2').html('<div class="top_middle_insupp">'+VariantsInfo[1].supply+'</div><div class="top_last_insupp">£'+subprice+' / bottle</div>');   
     // $('.offer-part.op3').html(VariantsInfo[0][od_filter].supply);
  }
  else{
   // $('.offer-part.op2').html('<div class="top_middle_insupp">'+VariantsInfo[1].supply+'</div><div class="top_last_insupp">£'+otpEachPrice+' / bottle</div>');   
   
  }  
  }
  else
  {
    $('.offer-part.op2').hide();
  }
  if (typeof VariantsInfo[2] != "undefined")
  {

   


var variantData = VariantsInfo[2];
// Extract the number of bottles from the 'supply' field
var supply = parseInt(variantData.supply.split(" ")[0]); // This will extract the number (e.g., '1' from '1 Bottle')
 
// Calculate the price for one-time purchase and subscription
var otpEachPrice = variantData.price/100; // Price for one-time selection

var otpEachPrice = (otpEachPrice/ supply).toFixed(2);
      
var subEachPrice = parseFloat(variantData.sub_price);
    //alert(subEachPrice);// Price for subscription selection
   var subprice  = (subEachPrice / supply).toFixed(2);
if(purchaseoptiond == 'subscription'){
   //$('.offer-part.op3').html('<div class="top_middle_insupp">'+VariantsInfo[2].supply+'</div><div class="top_last_insupp">£'+subprice+' / bottle</div>');   
     // $('.offer-part.op3').html(VariantsInfo[0][od_filter].supply);
  }
  else{
   // $('.offer-part.op3').html('<div class="top_middle_insupp">'+VariantsInfo[2].supply+'</div><div class="top_last_insupp">£'+otpEachPrice+' / bottle</div>');   
   
  }  
  }
  else
  {
    $('.offer-part.op3').hide();
  }


  }
  
  
});
/* Subscription tupe click option functionality*/
$(document).on('click', '.tb', function(event) {
  event.preventDefault();
  /* Act on the event */
  $('.tb').removeClass('active');
  $(this).addClass('active');
  $('.add_to_cart').attr('rel',$(this).attr('rel'));
  $('.offer-part.active').trigger('click');
   var titlepro = $('.pr_name').html();

  $('.dv.active').trigger('click');
  

   if(titlepro == 'Multivitamin For Men and Women Delayed Release'){
  $('.dv.active').trigger('click');
  }


    
          var dt = JSON.parse($('.new_buyboxlayout .offer-part.active').attr('data-total'));


  
       
const selectedOption = dt.supply;
// Override prices for 6-week and 12-week supplies
   if (selectedOption === '6 Week Supply') {
  var  subscriptionPrice = $('#subforsix').val(); // Override for 6-week supply
    
  var  oneTimePrice = $('#oneforsix').val(); // Override for 6-week supply
  } else if (selectedOption === '12 Week Supply') {
   var subscriptionPrice = $('#subfortw').val(); // Override for 12-week supply
    var oneTimePrice = $('#onefortw').val(); // Override for 12-week supply
  }
      else if (selectedOption === '2 Week Supply') {
    var subscriptionPrice = $('#subfortwo').val(); // Override for 12-week supply
    var oneTimePrice = $('#onefortwo').val(); // Override for 12-week supply
  }

   $('.bx').each(function(){
     var getno = $(this).find('.qty').length;
     if(getno > 0){
          $(this).find('.qty').replaceWith('<div class="lk flv_rt">Add +</div>');
     }
    
    });
    
     
   var perpouchsubscriptionone = $('#tweepricepersub').val();
    var perpouchone = $('#tweepriceperone').val();
     var perpouchsubscriptiontwo = $('#sixpricepersub').val();
    var perpouchtwo = $('#sixpriceperone').val();
     var perpouchsubscriptionthree =  $('#twopricepersub').val();
    var perpouchthree =  $('#twopriceperone').val();
    var relval =    $('.tb.active').attr('rel');
        
      if(relval == 'subscription'){
    $('.add_to_cart').find('.totalprice').text('£'+subscriptionPrice.toString());  
 $('.offer-part.op1').find('.top_last_insupp').html('£'+perpouchsubscriptionone+' / pouch</div>');   
 $('.offer-part.op2').find('.top_last_insupp').html('£'+perpouchsubscriptiontwo+' / pouch</div>');     
 $('.offer-part.op3').find('.top_last_insupp').html('£'+perpouchsubscriptionthree+' / pouch</div>');  

    // const $bundleSelect = $('.rb-frequency').find('#selling-plan-list');
// var idx = 1;
//         const selectEl = document.getElementById('selling-plan-list');
//   if (!selectEl || !selectEl.options[idx]) return;
//   selectEl.selectedIndex = idx;
//   // dispatch native + jQuery change
//   selectEl.dispatchEvent(new Event('change', { bubbles: true }));
//   $(selectEl).trigger('change');

      }
      else{
         
        $('.add_to_cart').find('.totalprice').text('£'+oneTimePrice.toString()); 
         $('.offer-part.op1').find('.top_last_insupp').html('£'+perpouchone+' / pouch</div>');   
 $('.offer-part.op2').find('.top_last_insupp').html('£'+perpouchtwo+' / pouch</div>');     
 $('.offer-part.op3').find('.top_last_insupp').html('£'+perpouchthree+' / pouch</div>'); 


  //       var idx = 0;
  //       const selectEl = document.getElementById('selling-plan-list');
  // if (!selectEl || !selectEl.options[idx]) return;
  // selectEl.selectedIndex = idx;
  // // dispatch native + jQuery change
  // selectEl.dispatchEvent(new Event('change', { bubbles: true }));
  // $(selectEl).trigger('change');
      }
});
/** add to cart button click event **/
$(document).on('click', '.add_to_cartr', function(event) {
    event.preventDefault();
    /* Act on the event */
    var sellingplan = $('.offer-part.active').attr('data-sellingplan');
    var variationid = $('.offer-part.active').attr('data-variationid');
    var purchasetype = $(this).attr('rel');
    var payloaddata = {};
    if (purchasetype == 'subscription') {
        payloaddata = {};
        payloaddata = {quantity: 1, id: variationid, properties: {}, selling_plan: sellingplan};
    }
    else if (purchasetype == 'onetime'){
        payloaddata = {};
        payloaddata = {quantity: 1, id: variationid, properties: {}};
    }
    $.ajax({
        url: '/cart/add.js',
        type: 'POST',
        dataType: 'json',
        data: payloaddata,
    })
    .done(function(res) {
        console.log("success");
        //console.log(res);
      
       if (purchasetype == 'onetime'){
     
      // $('#confirmation-message').addClass("show");
       // $('#confirmation-message').removeClass("hidden");
   
      }
     //window.Rebuy.SmartCart.show(); 
    })
    .fail(function(res) {
        console.log("error");
        console.log(res);
    })
    .always(function(res) {
        console.log("complete");
    //window.location.href= "https://rockandroses.life/cart";
        //console.log(res);
    });
    //console.log('payloaddata',payloaddata);
});
/*Find lowest price available*/
function getLowestItem(od_variantdata, filter){
    var max = Infinity;
    var titleValue;
    var itemValue;
    $.each(od_variantdata, function(index, val) {
         /* iterate through array or object */
        titleValue = val.title.match(/\d+/)[0];
        titleValue = parseInt(titleValue);
        if (val[filter] < max) {
            max = val.price;
            itemValue = (max/titleValue)/100;
            itemValue = itemValue.toFixed(3);
        }
    });
    return itemValue;
}
function getVariantsInfo(od_variantdata, od_productDiscount, od_filter, od_producthandle) {
    var supplydata = [];
    var isSubscriptionEnable  = true;
    var sub_price = 0;
    var subID;
    var lowestprice = getLowestItem(od_variantdata, 'price');
    var variantTitleValue;
    var otp_each_price;
    var sub_each_price;
    var sub_cross_price;
    var otp_cross_price;
    var productDiscount = 0.00;
    if(od_productDiscount.length > 0)
    {
      productDiscount = parseFloat(od_productDiscount).toFixed(2);
    }
    
    console.log('productDiscount', (productDiscount));
    //console.log('od_variantdata',typeof od_productDiscount);
    //console.log('Lowestprice',lowestprice);
    $.each(od_variantdata, function(index, val) {
             /* iterate through array or object */
        var flavour = [];
        var sellingplan;
        variantTitleValue = val.title.match(/\d+/)[0];
        variantTitleValue = parseInt(variantTitleValue);
        var otp_total = Math.round(lowestprice * variantTitleValue);
        otp_cross_price = Math.round(otp_total-(val.price/100));
        switch (od_producthandle) {

         case 'glow-powder-marine-collagen-drink':
              otp_each_price = ((val.price/100)/(variantTitleValue /2));
            break;

            case 'joint-powder':
              otp_each_price = ((val.price/100)/(variantTitleValue /2));
            break;

          case 'glow-powder':
              otp_each_price = ((val.price/100)/(variantTitleValue /2));
            break;
          case 'multivitamin':
              otp_each_price = ((val.price/100)/(variantTitleValue));
            break;
          case 'biotin':
              otp_each_price = ((val.price/100)/(variantTitleValue));
            break;
          default:
                  otp_each_price = ((val.price/100)/(variantTitleValue));
        }
        //console.log(index+' - '+variantTitleValue,(val.price/100));
        if(isSubscriptionEnable)
        {
            variantprice = parseFloat(val.price/100);
            //sub_price = variantprice - ( variantprice / 10 );
            if(od_productDiscount.length > 0)
            {
              sub_price = variantprice - ((productDiscount * variantprice) / 100);
              sub_price_view = sub_price.toFixed(2);
            }
            else
            {
              sub_price = variantprice;
              sub_price_view = sub_price.toFixed(2);
            }
            sub_cross_price = ((lowestprice * variantTitleValue)- parseFloat(sub_price));
            console.log('sub_price_view',sub_price_view);
           // console.log(index+' s- '+variantTitleValue,( (sub_price)));
            switch (od_producthandle) {
             case 'glow-powder-marine-collagen-drink':
                if(val.option2.match(/\d+/)[0] == '12')
                {
                    sellingplan = val.selling_plan_allocations[2].selling_plan_id
                }
                else if (val.option2.match(/\d+/)[0] == '6')
                {
                    sellingplan = val.selling_plan_allocations[1].selling_plan_id
                }
                else if (val.option2.match(/\d+/)[0] == '2')
                {
                    sellingplan = val.selling_plan_allocations[0].selling_plan_id
                }
                sub_each_price = ((parseFloat(sub_price))/(variantTitleValue /2));
                break;

 case 'joint-powder':
                if(val.option2.match(/\d+/)[0] == '12')
                {
                    sellingplan = val.selling_plan_allocations[2].selling_plan_id
                }
                else if (val.option2.match(/\d+/)[0] == '6')
                {
                    sellingplan = val.selling_plan_allocations[1].selling_plan_id
                }
                else if (val.option2.match(/\d+/)[0] == '2')
                {
                    sellingplan = val.selling_plan_allocations[0].selling_plan_id
                }
                sub_each_price = ((parseFloat(sub_price))/(variantTitleValue /2));
                break;



              case 'glow-powder':
                if(val.option2.match(/\d+/)[0] == '12')
                {
                    sellingplan = val.selling_plan_allocations[2].selling_plan_id
                }
                else if (val.option2.match(/\d+/)[0] == '6')
                {
                    sellingplan = val.selling_plan_allocations[1].selling_plan_id
                }
                else if (val.option2.match(/\d+/)[0] == '2')
                {
                    sellingplan = val.selling_plan_allocations[0].selling_plan_id
                }
                sub_each_price = ((parseFloat(sub_price))/(variantTitleValue /2));
                break;
              case 'multivitamin':
                if(val.option2.match(/\d+/)[0] == '1')
                {
                    sellingplan = val.selling_plan_allocations[0].selling_plan_id
                }
                else if (val.option2.match(/\d+/)[0] == '3')
                {
                    sellingplan = val.selling_plan_allocations[1].selling_plan_id
                }
                else if (val.option2.match(/\d+/)[0] == '6')
                {
                    sellingplan = val.selling_plan_allocations[2].selling_plan_id
                }
                sub_each_price = ((parseFloat(sub_price))/(variantTitleValue));
                break;
              case 'biotin':
                if(val.option1.match(/\d+/)[0] == '1')
                {
                    sellingplan = val.selling_plan_allocations[0].selling_plan_id
                }
                else if (val.option1.match(/\d+/)[0] == '3')
                {
                    sellingplan = val.selling_plan_allocations[1].selling_plan_id
                }
                else if (val.option1.match(/\d+/)[0] == '6')
                {
                    sellingplan = val.selling_plan_allocations[2].selling_plan_id
                }
                sub_each_price = ((parseFloat(sub_price))/(variantTitleValue));
                break;
              default:
                if(val.option1.match(/\d+/)[0] == '1')
                {
                    sellingplan = val.selling_plan_allocations[0].selling_plan_id
                }
                else if (val.option1.match(/\d+/)[0] == '3')
                {
                    sellingplan = val.selling_plan_allocations[1].selling_plan_id
                }
                else if (val.option1.match(/\d+/)[0] == '6')
                {
                    sellingplan = val.selling_plan_allocations[2].selling_plan_id
                }
                sub_each_price = ((parseFloat(sub_price))/(variantTitleValue));
                /*
                var otp_cross_price = Math.round(otp_total-(val.price/100));
                if(variantTitleValue == 1){
                    otp_each_price = (val.price/100);
                    sub_each_price = (parseFloat(sub_price));
                }
                else if (variantTitleValue == 3){
                    otp_each_price = ((val.price/100)/3);
                    sub_each_price = (parseFloat(sub_price)/3);
                }
                else if (variantTitleValue == 6){
                    otp_each_price = ((val.price/100)/6);
                    sub_each_price = (parseFloat(sub_price)/6);
                }
                sub_cross_price = ((lowestprice * variantTitleValue)- parseFloat(sub_price));*/
            }
        }
        if(od_filter == '')
        {
          flavour = {id:val.id, title:val.title, supply:val.option1, sellingplan:sellingplan, price: val.price,comp_price: val.compare_at_price, subid: subID, sub_price: sub_price_view,otp_cross_price:otp_cross_price,otp_each_price: otp_each_price, sub_each_price: sub_each_price, sub_cross_price: sub_cross_price};
          supplydata.push(flavour);
        }
        else if(od_filter == val.option1)
        {
          flavour[val.option1] = {id:val.id, title:val.title, supply:val.option2, sellingplan:sellingplan, price: val.price,comp_price: val.compare_at_price, subid: subID, sub_price: sub_price_view,otp_cross_price:otp_cross_price,otp_each_price: otp_each_price, sub_each_price: sub_each_price, sub_cross_price: sub_cross_price};
          supplydata.push(flavour);
        }
        
        });
    return supplydata;
}
});

 $(document).on('click touchstart','#confirm-request', function () {
 //$('#confirm-request').click(function() {
    // Send AJAX request to send-quote.php

$.ajax({
type: 'POST',
url: '/cart/change.js',
// describe the data you want to change here

data:       {
  'line': 2,
  'quantity': 0
},
dataType: 'json',
success: function() {

var sellingplan = $('.offer-part.active').attr('data-sellingplan');
    var variationid = $('.offer-part.active').attr('data-variationid');
    var purchasetype = $(this).attr('rel');
    var payloaddata = {};
    payloaddata = {quantity: 1, id: variationid, properties: {}, selling_plan: sellingplan};


    $.ajax({
        url: '/cart/add.js',
        type: 'POST',
        dataType: 'json',
        data: payloaddata,
    })
    .done(function(res) {
        console.log("success");


    //  $('#confirmation-message').addClass("hidden");
       // $('#confirmation-message').removeClass("show");
      
    })
    .fail(function(res) {
        console.log("error");
        console.log(res);
    })
    .always(function(res) {
        console.log("complete");
        //console.log(res);
    });

  
},
error: function(XMLHttpRequest, textStatus) {

}
});




  });
 
  // Handle cancellation
  $('#cancel-request').click(function() {
    // $('#confirmation-message').hide();
    //   $('.overlays').hide();

    $('#confirmation-message').addClass("hidden");
        $('#confirmation-message').removeClass("show");
  });
$('.close-btn').click(function() {
    // $('#confirmation-message').hide();
    //   $('.overlays').hide();

    $('#confirmation-message').addClass("hidden");
        $('#confirmation-message').removeClass("show");
  });


$(document).ready(function () {
  // Parse the product variants JSON from the data-productvariants attribute
  const productVariants = JSON.parse(
    $('.rgt_col.info.oddit_product').attr('data-productvariants')
  );

  // Function to update the plus and minus buttons with the active offer-part’s data
  function updateOfferControlData($bx) {
    const selectedFlavor = $bx.find('.t1').text().trim(); // Get the selected flavor
    const selectedSupplyOption = '2 Week Supply'; // Get the active supply option

    // Find the matching variant
    const matchingVariant = productVariants.find(variant => {
      return (
        variant.option1 === selectedFlavor && variant.option2 === selectedSupplyOption
      );
    });



    
    if (matchingVariant) {
      // Extract the required values
      const variationId = matchingVariant.id;
      const sellingPlanId =
        matchingVariant.selling_plan_allocations[0]?.selling_plan_id || null;

      // Update the plus and minus buttons within this specific box
      $bx.find('.plus').attr({
        'data-variationid': variationId,
        'data-sellingplan': sellingPlanId,
      });
      $bx.find('.minus').attr({
        'data-variationid': variationId,
        'data-sellingplan': sellingPlanId,
      });
    } else {
      console.error(`No matching variant found for flavor: ${selectedFlavor} and supply option: ${selectedSupplyOption}`);
    }
  }




  
  // "Add +" click: replace the link with quantity controls in that specific box
  $(document).on('click', '.lk', function () {
    const $bx = $(this).closest('.bx'); // Get the parent flavour box

   $('.lk').each(function () {
      const $thislk = $(this);
     $thislk.parents('.bx').removeClass('active');
    });

    

    // Determine the active supply option
    const $offer = $('.desktop_offer .offer-part.active');
    if (!$offer.length) {
      $offer = $('.desktop_offer .offer-part').first();
    }

    const supplyOption = $offer.find('.top_middle_insupp').text().trim();

    // Define maximum allowed total quantity for this supply option
    let maxAllowed = Infinity;
    if (supplyOption === '2 Weeks') {
      maxAllowed = 1;
    } else if (supplyOption === '6 Weeks') {
      maxAllowed = 3;
    } else if (supplyOption === '12 Weeks') {
      maxAllowed = 6;
    }

    // Sum the quantities across all boxes
    let totalQty = 0;
    $('.bx').each(function () {
      const $thisBox = $(this);
      const $thisNm = $thisBox.find('.nm').first();
      if ($thisNm.length) {
        totalQty += parseInt($thisNm.text().trim(), 10);
      }
    });

    // If the global total is already at or above the allowed maximum, do not convert
    if (totalQty >= maxAllowed) {
      //alert(`Maximum global quantity for ${supplyOption} is ${maxAllowed}.`);
           const remaining = maxAllowed - totalQty;

alert(`Select ${remaining} More Flavour${remaining > 1 ? 's' : ''}`);
      return; // Abort the conversion
    }

    // Otherwise, convert the "Add +" link to quantity controls
    if (!$bx.hasClass('active')) {
      $bx.addClass('active');
    }

    const qtyControl =
      '<div class="qty">' +
      '<div class="minus">-</div>' +
      '<div class="plus">+</div>' +
      '<div class="nm">1</div>' +
      '</div>';
    $(this).replaceWith(qtyControl);

    // Update the offer control data for the current box
    updateOfferControlData($bx);
    updateGlobalCartTotal();


    const selectedFlavor = $bx.find('.t1').text().trim(); // Get the selected flavor
    const selectedSupplyOption = '2 Week Supply'; // Get the active supply option
  const matchingVariant = productVariants.find(variant => {
      return (
        variant.option1 === selectedFlavor && variant.option2 === selectedSupplyOption
      );
    });


  const label = matchingVariant.id;

  // 2) Make sure the bundle section is visible
 // $('[data-section-id="recharge-bundles-widget"]').show();

  // 3) Find the rb-item by aria-label and click it
  const $rbItem = $(`.rb-item[data-rb-item-id="${label}"]`);
  if ($rbItem.length) {
    // either trigger the click…
    $rbItem[0].click();
    // …or select its inner input directly:
     $rbItem.find('input.rb-input').val(1).trigger('change');
    $rbItem.find('.rb-btn-qty-plus').trigger('click');
  }


    
  });

  // PLUS BUTTON CLICK: increment quantity in the current box
  $(document).on('click', '.plus', function () {
    const $bx = $(this).closest('.bx');
    const $nm = $bx.find('.nm').first();
    let currentVal = parseInt($nm.text().trim(), 10);

    // Determine the active supply option
    const $offer = $('.desktop_offer .offer-part.active');
    if (!$offer.length) {
      $offer = $('.desktop_offer .offer-part').first();
    }

    const supplyOption = $offer.find('.top_middle_insupp').text().trim();

    // Define maximum allowed total quantity for this supply option
    let maxAllowed = Infinity;
    if (supplyOption === '2 Weeks') {
      maxAllowed = 1;
    } else if (supplyOption === '6 Weeks') {
      maxAllowed = 3;
    } else if (supplyOption === '12 Weeks') {
      maxAllowed = 6;
    }

    // Compute the global total if we were to increment this box by 1
    let totalQty = 0;
    $('.bx').each(function () {
      const $thisBox = $(this);
      const $thisNm = $thisBox.find('.nm').first();
      if ($thisNm.length) {
        // For the current box, simulate an increment
        if ($thisBox.is($bx)) {
          totalQty += currentVal + 1;


   const selectedFlavor = $bx.find('.t1').text().trim(); // Get the selected flavor
    const selectedSupplyOption = '2 Week Supply'; // Get the active supply option
  const matchingVariant = productVariants.find(variant => {
      return (
        variant.option1 === selectedFlavor && variant.option2 === selectedSupplyOption
      );
    });


  const label = matchingVariant.id;

  // 2) Make sure the bundle section is visible
 // $('[data-section-id="recharge-bundles-widget"]').show();

  // 3) Find the rb-item by aria-label and click it
  const $rbItem = $(`.rb-item[data-rb-item-id="${label}"]`);
  if ($rbItem.length) {
    // either trigger the click…
    $rbItem[0].click();
    // …or select its inner input directly:
     $rbItem.find('input.rb-input').val(currentVal + 1).trigger('change');
     $rbItem.find('.rb-btn-qty-plus').trigger('click');
  }

          
        } else {
          totalQty += parseInt($thisNm.text().trim(), 10);
        }
      }
    });

    if (totalQty <= maxAllowed) {
      $nm.text(currentVal + 1);
    } else {
           const remaining = maxAllowed - totalQty;

alert(`Select ${remaining} More Flavour${remaining > 1 ? 's' : ''}`);
      //alert(`Maximum global quantity for ${supplyOption} is ${maxAllowed}.`);
      return; // Do not increment
    }

     
  

    // Update the offer control data for the current box
    updateOfferControlData($bx);
    updateGlobalCartTotal();
  });

  // MINUS BUTTON CLICK: decrement quantity in the current box
  $(document).on('click', '.minus', function () {
    const $bx = $(this).closest('.bx');
    const $nm = $bx.find('.nm').first();
    let currentVal = parseInt($nm.text().trim(), 10);

    if (currentVal > 1) {
      $nm.text(currentVal - 1);
var getgy = $nm.text(currentVal - 1);

   const selectedFlavor = $bx.find('.t1').text().trim(); // Get the selected flavor
    const selectedSupplyOption = '2 Week Supply'; // Get the active supply option
  const matchingVariant = productVariants.find(variant => {
      return (
        variant.option1 === selectedFlavor && variant.option2 === selectedSupplyOption
      );
    });


  const label = matchingVariant.id;

  // 2) Make sure the bundle section is visible
 // $('[data-section-id="recharge-bundles-widget"]').show();

  // 3) Find the rb-item by aria-label and click it
  const $rbItem = $(`.rb-item[data-rb-item-id="${label}"]`);
  if ($rbItem.length) {
    // either trigger the click…
    $rbItem[0].click();
    // …or select its inner input directly:
     $rbItem.find('input.rb-input').val(getgy).trigger('change');
    $rbItem.find('.rb-btn-qty-minus').trigger('click');
  }
      
    } else {
      // When quantity would drop to 0, remove the quantity control and revert to "Add +"
      $bx.find('.qty').replaceWith('<div class="lk flv_rt">Add +</div>');
      $bx.removeClass('active');
    }

   

    // Update the offer control data for the current box
    updateOfferControlData($bx);
    updateGlobalCartTotal();
  });






  $('.add_to_cart').on('click', async function (e) {
  e.preventDefault();


const $offer = $('.desktop_offer .offer-part.active');
    if (!$offer.length) {
      $offer = $('.desktop_offer .offer-part').first();
    }

    const supplyOption = $offer.find('.top_middle_insupp').text().trim();


 let maxAllowed = Infinity;
    if (supplyOption === '2 Weeks') {
      maxAllowed = 1;
    } else if (supplyOption === '6 Weeks') {
      maxAllowed = 3;
    } else if (supplyOption === '12 Weeks') {
      maxAllowed = 6;
    }

    // Compute the global total if we were to increment this box by 1
    let totalQty = 0;
  $('.bx').each(function () {
      const $thisBox = $(this);
      const $thisNm = $thisBox.find('.nm').first();
      if ($thisNm.length) {
        totalQty += parseInt($thisNm.text().trim(), 10);
      }
    });

    // If the global total is already at or above the allowed maximum, do not convert
    if (totalQty < parseInt(maxAllowed)) {
           const remaining = maxAllowed - totalQty;

alert(`Select ${remaining} More Flavour${remaining > 1 ? 's' : ''}`);
     // alert(`Maximum global quantity for ${supplyOption} is ${maxAllowed}.`);
      return; // Abort the conversion
    }


  $('#loader-overlay').show(); // SHOW LOADER
  // 1) Parent bundle info (main Recharge bundle product)

   
    var varid = $('.offer-part.active').attr('data-varid');
    var prid = $('.offer-part.active').attr('data-proid');
    var sellid = $('.offer-part.active').attr('data-sellid');

  var relval =    $('.tb.active').attr('rel');
      //alert(relval);
      if(relval == 'subscription'){

            
    var bundleProductData = {
      variantId: varid,         // Your parent bundle variant ID
      productId: prid,         // Your bundle product ID
      sellingPlan: sellid            // Recharge selling plan ID (optional)
    }
      }
    else{
          
    var bundleProductData = {
      variantId: varid,         // Your parent bundle variant ID
      productId: prid,         // Your bundle product ID
               
    }
    }


    // Step 1: Gather flavor selections
    const selections = [];
    const contentsArray = [];
const rcBundleId = 'rc_' + Date.now().toString(36) + Math.random().toString(36).substring(2, 10);
    $('.bx').each(function () {
   const qty = parseInt($(this).find('.nm').text(), 10);
      if (qty > 0) {
          var titleofp = $('.pr_name').html();
          
        if ($('body').hasClass('product-joint-powder-bundle')) {

      var collectionId = '675013886338';
    
          }
          else{
            var collectionId = '669581574530';
          }
          //let collectionId = '669581574530';
        console.log('colid'+collectionId);
        const productId = $('#promainid').val();
      const variantId = String($(this).find('.plus').attr('data-variationid'));
        //alert(variantId);
  
     const title = $(this).find('.t1').text().trim() || 'Flavor';
        //const title = variantId;

        selections.push({
          collectionId: collectionId,
          externalProductId: productId,
          externalVariantId: variantId,
          quantity: qty
        });

        contentsArray.push(`${qty}x ${title}`);
      }
    });

    if (!selections.length) {
      return alert('Please select at least one flavor.');
    }

    // Step 2: Build bundle object and get Recharge's _rb_id
    const bundle = {
      externalVariantId: bundleProductData.variantId,
      externalProductId: bundleProductData.productId,
      selections: selections
    };
   //console.log(bundle);
    try {
      const rbId = await recharge.bundle.getBundleId(bundle);

    // Conditionally add the second product
// Check cart contents before adding the second product
let shouldAddSecondProduct = false;
 const cartItems = [];
 //on after mixer available
// if ($('.offer-part.op1').hasClass('active')) {
//   try {
//     const cartRes = await fetch('/cart.js');
//     const cart = await cartRes.json();
 
//     const alreadyInCart = cart.items.some(item => item.variant_id === 55377319952770);
//     if (!alreadyInCart) {
//       shouldAddSecondProduct = true;
//     }
//   } catch (err) {
//     console.error('Error checking cart contents', err);
//   }
// }
 
if (shouldAddSecondProduct) {
  cartItems.push({
    id: 55377319952770,
    quantity: 1
  });
}


        //  const cartItems= [
        //   {
        //     id: bundleProductData.variantId,
        //     quantity: 1,
        //     selling_plan: bundleProductData.sellingPlan,
        //     properties: {
        //       _rb_id: rbId,
        //       _rc_bundle: rcBundleId,
        //       Contents: contentsArray.join('\n')
        //     }
        //   }
        // ]

        cartItems.push({
  id: bundleProductData.variantId,
  quantity: 1,
  selling_plan: bundleProductData.sellingPlan,
  properties: {
    _rb_id: rbId,
    _rc_bundle: rcBundleId,
    Contents: contentsArray.join('\n'),
    ContentsCompact: contentsArray.join('|')
  }
});


   
  
 const cartData = {
  items: cartItems
};

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(cartData)
      });

      if (!response.ok) throw await response.json();
window.ReChargeCartUpdate();
     // window.location.href = '/cart';
        if (window.ReChargeCartUpdate) {
      window.ReChargeCartUpdate();
    } else if (window.RECHARGE_CART) {
      window.RECHARGE_CART.updateCart();
    }

    } catch (err) {
      console.error('Add to cart error:', err);
      //alert('Something went wrong. Please try again.');
    }
    finally {
    $('#loader-overlay').hide(); // HIDE LOADER
  }
});


  
  
  // Function to update the global cart total
  function updateGlobalCartTotal() {
    let globalTotalPrice = 0;
    let globalQty = 0;

    // Loop through every box (.bx) that has a quantity control (.nm)
    $('.bx').each(function () {
      const $bx = $(this);
      const $nm = $bx.find('.nm').first();
      if ($nm.length) {
        const qty = parseInt($nm.text().trim(), 10) || 0;
        globalQty += qty;
        const unitPrice = parseFloat($bx.find('.plus').attr('data-unitprice')) || 0;
        globalTotalPrice += qty * unitPrice;
      }
    });

    // Update the global price display
   // $('.add_to_cart .totalprice').text('£' + globalTotalPrice.toFixed(2));

     
          var dt = JSON.parse($('.new_buyboxlayout .offer-part.active').attr('data-total'));
       
const selectedOption = dt.supply;
// Override prices for 6-week and 12-week supplies
  if (selectedOption === '6 Week Supply') {
  var  subscriptionPrice = $('#subforsix').val(); // Override for 6-week supply
    
  var  oneTimePrice = $('#oneforsix').val(); // Override for 6-week supply
  } else if (selectedOption === '12 Week Supply') {
   var subscriptionPrice = $('#subfortw').val(); // Override for 12-week supply
    var oneTimePrice = $('#onefortw').val(); // Override for 12-week supply
  }
      else if (selectedOption === '2 Week Supply') {
    var subscriptionPrice = $('#subfortwo').val(); // Override for 12-week supply
    var oneTimePrice = $('#onefortwo').val(); // Override for 12-week supply
  }
    
    
    var relval =    $('.tb.active').attr('rel');
       console.log('price'+selectedOption);
      if(relval == 'subscription'){
    $('.add_to_cart').find('.totalprice').text('£'+subscriptionPrice.toString());  
      }
      else{
        $('.add_to_cart').find('.totalprice').text('£'+oneTimePrice.toString()); 
      }

    // Determine the maximum allowed total quantity based on the active offer-part
    const $offer = $('.desktop_offer .offer-part.active');
    if (!$offer.length) {
      $offer = $('.desktop_offer .offer-part').first();
    }

    const supplyOption = $offer.find('.top_middle_insupp').text().trim();
    let maxAllowed = Infinity;
    if (supplyOption === '2 Weeks') {
      maxAllowed = 1;
    } else if (supplyOption === '6 Weeks') {
      maxAllowed = 3;
    } else if (supplyOption === '12 Weeks') {
      maxAllowed = 6;
    }

    // Update the add-to-cart button text and enabled state
    if (globalQty < maxAllowed) {
      const remaining = maxAllowed - globalQty;
      $('.add_to_cart .dd').text(`Select ${remaining} more flavour${remaining > 1 ? 's' : ''}`);
      $('.add_to_cart').addClass('disabled');
    } else {
      $('.add_to_cart .dd').text('Add To Cart');
      $('.add_to_cart').removeClass('disabled');
    }
  }
});

$('.new_buyboxlayout .offer-part').click(function(){
    
    if($(this).hasClass('active')){

    }
    else{

    $('.bx').each(function(){
     var getno = $(this).find('.qty').length;
     if(getno > 0){
          $(this).find('.qty').replaceWith('<div class="lk flv_rt">Add +</div>');
     }
    
    });

      var dt = JSON.parse($(this).attr('data-total'));
       
const selectedOption = dt.supply;
// Override prices for 6-week and 12-week supplies
  if (selectedOption === '6 Week Supply') {
  var  subscriptionPrice = $('#subforsix').val(); // Override for 6-week supply
    
  var  oneTimePrice = $('#oneforsix').val(); // Override for 6-week supply
  } else if (selectedOption === '12 Week Supply') {
   var subscriptionPrice = $('#subfortw').val(); // Override for 12-week supply
    var oneTimePrice = $('#onefortw').val(); // Override for 12-week supply
  }
      else if (selectedOption === '2 Week Supply') {
    var subscriptionPrice = $('#subfortwo').val(); // Override for 12-week supply
    var oneTimePrice = $('#onefortwo').val(); // Override for 12-week supply
  }
 // const $bundleSelect = $('.rb-options').find('#product-variant-list');

 //  // 2) Set it to the supply string you want
 //  $bundleSelect.val(selectedOption);

 //  // 3) Fire both native and jQuery change events
 //  $bundleSelect[0].dispatchEvent(new Event('change', { bubbles: true }));
 //  $bundleSelect.trigger('change');
 


  $('.otp_each_price').text('£'+oneTimePrice.toString());
  $('.sub_each_price').text('£'+subscriptionPrice.toString());
  $('.sub_cross_price').text('£'+oneTimePrice.toString());
   var relval =    $('.tb.active').attr('rel');
      //alert(relval);
      if(relval == 'subscription'){
       
    $('.add_to_cart').find('.totalprice').text('£'+subscriptionPrice.toString());  


        
      }
      else{
        $('.add_to_cart').find('.totalprice').text('£'+oneTimePrice.toString()); 

      }
    }
    setTimeout(function() {
      if($('.offer-part.op1').hasClass('active')){
  totflavorcount ='Choose 6 Flavours';
 

}
if($('.offer-part.op2').hasClass('active')){
    totflavorcount ='Choose 3 Flavours';
   
}
if($('.offer-part.op3').hasClass('active')){
    totflavorcount ='Choose 1 Flavour';
  
}

    $('.add_to_cart').find('span.dd').html(totflavorcount);
    var procomp = $.trim($('.pr_name').html());
 
  if(procomp == 'Joint Powder Collagen Complexi'){
$('.add_to_cart').addClass('disable');
 $('.add_to_cart').find('span.dd').html('Out Of Stock');

  }

    },20);
   });

setTimeout(function() {
var pronames = $.trim($('.pr_name').html());



           var dt = JSON.parse($('.new_buyboxlayout .offer-part.active').attr('data-total'));
       
const selectedOption = dt.supply;

// Override prices for 6-week and 12-week supplies
 if (selectedOption === '6 Week Supply') {
  var  subscriptionPrice = $('#subforsix').val(); // Override for 6-week supply
    
  var  oneTimePrice = $('#oneforsix').val(); // Override for 6-week supply
  } else if (selectedOption === '12 Week Supply') {
   var subscriptionPrice = $('#subfortw').val(); // Override for 12-week supply
    var oneTimePrice = $('#onefortw').val(); // Override for 12-week supply
  }
      else if (selectedOption === '2 Week Supply') {
    var subscriptionPrice = $('#subfortwo').val(); // Override for 12-week supply
    var oneTimePrice = $('#onefortwo').val(); // Override for 12-week supply
  }
    
    
  $('.otp_each_price').text('£'+oneTimePrice.toString());
  $('.sub_each_price').text('£'+subscriptionPrice.toString());
  $('.sub_cross_price').text('£'+oneTimePrice.toString());

  if($('.offer-part.op1').hasClass('active')){
  totflavorcount ='Choose 6 Flavours';
 

}
if($('.offer-part.op2').hasClass('active')){
    totflavorcount ='Choose 3 Flavours';
   
}
if($('.offer-part.op3').hasClass('active')){
    totflavorcount ='Choose 1 Flavour';
  
}

    $('.add_to_cart').find('span.dd').html(totflavorcount);

var procomp = $.trim($('.pr_name').html());
 
  if(procomp == 'Joint Powder Collagen Complexi'){
$('.add_to_cart').addClass('disable');
 $('.add_to_cart').find('span.dd').html('Out Of Stock');

  }

    
},10);
//$('.desktop_offer').find('.offer-part.op1').trigger('click');

